var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteEnergy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.76667 11.0666H10.3417V17.0666C10.3417 17.95 11.4417 18.3666 12.025 17.7L18.3333 10.5333C18.8833 9.90831 18.4417 8.93331 17.6083 8.93331H15.0333V2.93331C15.0333 2.04997 13.9333 1.63331 13.35 2.29997L7.04167 9.46664C6.5 10.0916 6.94167 11.0666 7.76667 11.0666Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.08333 3.95831H1.25C0.908333 3.95831 0.625 3.67498 0.625 3.33331C0.625 2.99165 0.908333 2.70831 1.25 2.70831H7.08333C7.425 2.70831 7.70833 2.99165 7.70833 3.33331C7.70833 3.67498 7.425 3.95831 7.08333 3.95831Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 17.2917H1.25C0.908333 17.2917 0.625 17.0084 0.625 16.6667C0.625 16.325 0.908333 16.0417 1.25 16.0417H6.25C6.59167 16.0417 6.875 16.325 6.875 16.6667C6.875 17.0084 6.59167 17.2917 6.25 17.2917Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 10.625H1.25C0.908333 10.625 0.625 10.3417 0.625 10C0.625 9.65833 0.908333 9.375 1.25 9.375H3.75C4.09167 9.375 4.375 9.65833 4.375 10C4.375 10.3417 4.09167 10.625 3.75 10.625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteEnergy);
export default __webpack_public_path__ + "static/media/white-energy.f24ec6b041f5589d76b772548fa87078.svg";
export { ForwardRef as ReactComponent };